// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fa992c2e","732":"fcf4a7dc","977":"9ca66b80"}[chunkId] + ".chunk.js";
};